import { useRef } from "react";

/** Смахивание чипа (канон улёта/возврата useChipDrag) БЕЗ long-press — для чипов,
 *  у которых тап = действие (графики, грейды): смахнул → onSwipeAway(id), не
 *  дотянул → «примагничивание». swMoved гейтит click после жеста. */
export function useChipSwipe(onSwipeAway: (id: string) => void) {
  const sw = useRef<{ id: string; el: HTMLElement; x: number; y: number; dx: number; dy: number; moved: boolean } | null>(null);
  const swMoved = useRef(false);
  const swDown = (id: string, e: React.PointerEvent) => {
    const el = e.currentTarget as HTMLElement;
    el.style.transform = ""; el.style.opacity = ""; el.style.transition = "";
    try { el.setPointerCapture?.(e.pointerId); } catch { /* синтетика */ }
    sw.current = { id, el, x: e.clientX, y: e.clientY, dx: 0, dy: 0, moved: false };
    swMoved.current = false;
  };
  const swMove = (e: React.PointerEvent) => {
    const s = sw.current; if (!s) return;
    s.dx = e.clientX - s.x; s.dy = e.clientY - s.y;
    const dist = Math.hypot(s.dx, s.dy);
    if (dist > 10) { s.moved = true; swMoved.current = true; }
    if (s.moved) { s.el.style.transform = `translate(${s.dx}px, ${s.dy}px)`; s.el.style.opacity = String(Math.max(0.25, 1 - dist / 140)); }
  };
  const swUp = () => {
    const s = sw.current; sw.current = null; if (!s) return;
    const dist = Math.hypot(s.dx, s.dy);
    const el = s.el;
    if (dist > 56) {
      const k = 1 + 200 / Math.max(dist, 1);
      el.style.transition = "transform 0.2s ease-in, opacity 0.2s ease-in";
      el.style.transform = `translate(${s.dx * k}px, ${s.dy * k}px) scale(0.6) rotate(${s.dx < 0 ? -10 : 10}deg)`;
      el.style.opacity = "0";
      setTimeout(() => { onSwipeAway(s.id); el.style.cssText = ""; }, 180);
      return;
    }
    el.style.transition = "transform 0.18s cubic-bezier(0.2, 0.9, 0.3, 1.3), opacity 0.15s";
    el.style.transform = ""; el.style.opacity = "";
    setTimeout(() => { el.style.transition = ""; }, 220);
  };
  return { swDown, swMove, swUp, swMoved };
}
